import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CampaignService } from '@uw/core/services/campaign.service';
import { Observable } from 'rxjs';
import { RouterOutlet } from '@angular/router';
import { AsyncPipe } from '@angular/common';

@Component({
    templateUrl: './standalone-parent-page.component.html',
    styleUrls: ['./standalone-parent-page.component.scss'],
    imports: [RouterOutlet, AsyncPipe, TranslateModule]
})
export class StandaloneParentPageComponent implements OnInit {

  readonly currentLanguage = this.translateService.currentLang;

  mainHeaderLogo$!: Observable<string>;
  mainHeaderLogo2$!: Observable<string>;
  // mainHeaderLogo2$!: Observable<{logo2: string, displayLogo2: boolean, displayDefaultLogo: boolean}>;
  mainHeaderLogoAlt$!: Observable<string>;
  mainHeaderLogo2Alt$!: Observable<string>;

  constructor(private translateService: TranslateService, private campaignService: CampaignService) { }

  ngOnInit(): void {

    this.mainHeaderLogo$ = this.campaignService.companyLogo();
    this.mainHeaderLogo2$ = this.campaignService.companyLogo2();
    // this.mainHeaderLogo2$ = combineLatest([this.campaignService.companyLogo2(), this.mainHeaderLogo$]).pipe(
    //   map(([logo2, logo1]) => {
    //     let displayDefaultLogo = (logo1 && !logo2) ? true:false;
    //     let displayLogo2 = (logo2 )? true: false; 
    //     return {logo2, displayLogo2, displayDefaultLogo}
    //   })
    // );
    this.mainHeaderLogoAlt$ = this.campaignService.companyLogoAlt();
    this.mainHeaderLogo2Alt$ = this.campaignService.companyLogo2Alt();
  }

  

}
